import useTheme from '@/utils/hooks/useTheme'
import { UserPreference } from '@/utils/hooks/useUserPreference'
import { css } from '@emotion/react'
import { HTMLAttributes } from 'react'
import Button from './Button'

const THEME_LOCALE: Record<UserPreference['theme'], string> = {
	AUTO: '自动',
	LIGHT: '浅色',
	DARK: '深色',
}

export default function ThemeSwitcher({ ...props }: HTMLAttributes<HTMLDivElement>) {
	const [theme, setTheme] = useTheme()

	return (
		<div
			css={css`
				display: flex;
				gap: 4px;
				align-items: center;

				.jk-btn-text {
					border: 1px solid transparent;
				}
			`}
			{...props}
		>
			{Object.entries(THEME_LOCALE).map(([key, label]) => {
				const isActive = key === theme
				return (
					<Button
						appearance={isActive ? 'ghost' : 'text'}
						size="sm"
						key={key}
						onClick={() => {
							setTheme(key as UserPreference['theme'])
						}}
					>
						{label}
					</Button>
				)
			})}
		</div>
	)
}
